import React from 'react';
import './pagefooter.css';
import { Helmet } from 'react-helmet-async';

const AppsPrivacy = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Aikyam Sports Science</title>

      <meta
        name="description"
        content="Privacy Policy for the Aikyam Sports Science fitness tips and workout app. This app does not collect, store, or share personal user data."
      />

      <link
        rel="canonical"
        href="https://aikyamsports.com/appsprivacy"
      />

      <meta
        property="og:title"
        content="Privacy Policy | Aikyam Sports Science"
      />

      <meta
        property="og:description"
        content="Learn how Aikyam Sports Science respects your privacy. This fitness tips and workout app does not collect personal user data."
      />

      <meta
        property="og:url"
        content="https://aikyamsports.com/appsprivacy"
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:image"
        content="https://aikyamsports.com/logo11.png"
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content="Privacy Policy | Aikyam Sports Science"
      />

      <meta
        name="twitter:description"
        content="Privacy Policy for the Aikyam Sports Science fitness tips and workout app."
      />

      <meta
        name="twitter:image"
        content="https://aikyamsports.com/logo11.png"
      />
    </Helmet>

    <div className="policy-page">
      <h1>Privacy Policy</h1>

      <p>
        Aikyam Sports Science respects your privacy. This Privacy Policy
        explains how the Aikyam Sports Science Restore fitness tips app and Reactive rehab app
        handles user information.
      </p>

      <h2>No Data Collection</h2>

      <p>
        This app does not collect, store, process, or share personal
        information from users. You can use the app without creating an
        account or providing personal information.
      </p>

      <h2>Information We Collect</h2>

      <p>
        We do not collect personal information such as your name, email
        address, phone number, location, contacts, photographs, or other
        personally identifiable information through this app.
      </p>

      <h2>Workout and Fitness Content</h2>

      <p>
        The app provides fitness tips, workout guidance, exercise information,
        and educational content intended to help users learn about fitness,
        exercise, and healthy lifestyle practices.
      </p>

      <h2>Data Storage</h2>

      <p>
        The app does not store personal user information on our servers or
        maintain user accounts.
      </p>

      <h2>Analytics and Tracking</h2>

      <p>
        This app does not use personal information for tracking or behavioral
        profiling.
      </p>

      <h2>Children's Privacy</h2>

      <p>
        We do not knowingly collect personal information from children or
        other users through this app.
      </p>

      <h2>Data Retention and Deletion</h2>

      <p>
        Because the app does not collect or store personal user information,
        there is no personal user data retained by Aikyam Sports Science and
        no personal data deletion request is required.
      </p>

      <h2>Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy if the app's functionality or
        privacy practices change. Any updates will be published on this page.
      </p>

      <h2>Contact</h2>

      <p>
        Aikyam Sports Science is committed to respecting your privacy and
        providing a simple and secure fitness and workout experience.
      </p>
    </div>
  </>
);

export default AppsPrivacy;